const AUTH = "auth";
export const authKeys = {
	confirmEmail: [AUTH, "confirm-email"] as const,
	login: [AUTH, "login"] as const,
	register: [AUTH, "register"] as const,
	requestPasswordReset: [AUTH, "request-password-reset"] as const,
	resetPassword: [AUTH, "reset-password"] as const,
};
